import React, { useEffect, useState, }  from 'react';
import { useSelector,useDispatch } from 'react-redux';
import { GetUrl, GetMaintenanceUrl, CTicksToDateString } from '../Utility.js';
import { useNavigate } from 'react-router-dom';

function DetailModalType3({ isOpen, No, onClose}) {
    const state = useSelector((state)=>state);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [Title, setTitle] = useState("");
    const [Text, setText] = useState("");
    const [Time, setTime] = useState("");
    const [content, setContent] = useState('');
    const [ID, setID] = useState('');
   

    const [First, setFirst] = useState(true);

    const Close = (refresh) =>{
        onClose(refresh);
        setFirst(true);
    }

    const RequestQA = async (index) => 
    {
        try
        {
            if(state.Request === 1)
            {
                return;
            }

            var secretkey = sessionStorage.getItem("secret_key");
            if(secretkey === null)
            {
                alert('유저 정보 만료(다시 로그인 해주세요)');  
                navigate('/login'); // 로그인 성공 시 메인 페이지로 이동  
                return;    
            } 
            
            dispatch({type:'Request'});
            const response = await fetch(GetUrl() + 'Admin/AdminGetQA', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ secret_key : secretkey, no : index}),
            });

            if (response.ok) {
                const data = await response.json();
                if(data.result === 0)
                {
                    setTitle(data.title);
                    setText(data.text);
                    setTime(CTicksToDateString(data.create_at_time));
                    setID(data.id);
                    //setAnswer(data.answer);
                }
                else if(data.result === 14 ||
                        data.result === 16)
                {
                    alert('존재 하지 않는 티켓 입니다');  
                }
                else if(data.result === 15)
                {
                    alert('이미 사용한 티켓 입니다');  
                }
                else if(data.result === 3 ||
                        data.result === 1)
                {
                    alert('유저 정보 만료(다시 로그인 해주세요)');  
                    navigate('/login'); // 로그인 성공 시 메인 페이지로 이동
                }
                else if(data.result === 21) // 점검 중
                {
                    var startTime = CTicksToDateString(data.start_time);
                    var endTime = CTicksToDateString(data.end_time);
    
                    var message = `${startTime} ~ ${endTime} 점검 중 입니다. 잠시후에 이용해 주세요`;
                    alert(message);  
                    navigate('/login'); // 로그인 성공 시 메인 페이지로 이동
                }
            } 
            else
            {
                alert('Network Fail');
            }

            dispatch({type:'Response'});
        }
        catch(error)
        {
            alert('Network Fail');
            dispatch({type:'Response'});
            console.error(error);
        }
    };    

    if (!isOpen) return null;

    if(First === true)
    {
        setFirst(false);
        setTitle("");
        setText("");
        setTime("");
        setContent("");

        RequestQA(No);
    }

    const handleContentChange = (event) => {
          setContent(event.target.value);
      };

    const RequestSummit = async () => 
    {
        try
        {
            if(state.Request === 1)
            {
                return;
            }

            if(content === "")
            {
                alert('내용을 입력 해 주세요요');
                return;
            }

            var secretkey = sessionStorage.getItem("secret_key");
            if(secretkey === null)
            {
                alert('유저 정보 만료(다시 로그인 해주세요)');  
                navigate('/login'); // 로그인 성공 시 메인 페이지로 이동  
                return;    
            } 
            
            dispatch({type:'Request'});
            const response = await fetch(GetUrl() + 'Admin/AdminRegisterQAAnswer', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ secret_key : secretkey, no:No, text:content}),
            });

            if (response.ok) {
                const data = await response.json();
                if(data.result === 0)
                {
                    alert('1:1문의 등록 완료');  
                }
                else if(data.result === 14 ||
                        data.result === 16)
                {
                    alert('존재 하지 않는 티켓 입니다');  
                }
                else if(data.result === 15)
                {
                    alert('이미 사용한 티켓 입니다');  
                }
                else if(data.result === 3 ||
                        data.result === 1)
                {
                    alert('유저 정보 만료(다시 로그인 해주세요)');  
                    navigate('/login'); // 로그인 성공 시 메인 페이지로 이동
                }
                else if(data.result === 21) // 점검 중
                {
                    var startTime = CTicksToDateString(data.start_time);
                    var endTime = CTicksToDateString(data.end_time);
    
                    var message = `${startTime} ~ ${endTime} 점검 중 입니다. 잠시후에 이용해 주세요`;
                    alert(message);  
                    navigate('/login'); // 로그인 성공 시 메인 페이지로 이동
                }
            } 
            else
            {
                alert('Network Fail');
            }

            dispatch({type:'Response'});
            dispatch({type:'RefreshQAWait', Refresh:true});
            Close(true);
        }
        catch(error)
        {
            alert('Network Fail');
            dispatch({type:'Response'});
            console.error(error);
        }
    };    

    function Close_Type2()
    {
        Close(false);
    }

    return (
        <div className="detail-modal-type-3-overlay" onClick={Close_Type2}>
            <div className='detail-modal-type-3-container' onClick={(e) => e.stopPropagation()}>
                <div class="detail-modal-type-3-header">
                    <div class="title">{Title}</div>
                    <div class="info">
                        <span>작성자: {ID}</span>
                        <span>작성일: {Time}</span>
                        <button class="close-btn" onClick={Close_Type2}>닫기</button>
                    </div>
                </div>
                <div class="detail-modal-type-3-content">
                    <div class="detail-modal-type-3-label">Q:</div>
                    <div class="detail-modal-type-3-question-box">{Text}</div>
                    <div class="detail-modal-type-3-label">A:</div>
                    <div class="detail-modal-type-3-answer-box">
                        <textarea 
                            id="content" 
                            placeholder="내용을 입력하세요" 
                            value={content}
                            onChange={handleContentChange}>
                        </textarea>
                    </div>
                </div>
                <button class="detail-modal-type-3-overlay-submit-btn" onClick={RequestSummit}>제출</button>
            </div>
        </div>
    );
}

export default DetailModalType3;